import React, { useEffect, useState } from 'react';
import { useTalentos } from '../../../../application/talentos/hooks/useTalentos';
import ToolbarComponent from '../../../ui/section';
import DynamicTable from '../../../ui/table2';
import Loader from '../../../ui/loader';
import { IconButton } from '../../../ui/button';

const ApplicationsPage = (props) => {
    const {
        getApplications,
        updateApplicationStage,
        updateApplicationStatus,
        isLoading,
        error
    } = useTalentos();

    const [applications, setApplications] = useState([]);

    const columns = [
        { key: 'user', label: 'Postulante', style: { width: "25%" } },
        { key: 'job', label: 'Trabajo/Práctica', style: { width: "25%" } },
        { key: 'applicationType', label: 'Tipo', style: { width: "10%" } },
        { key: 'currentStage', label: 'Etapa', style: { width: "15%" } },
        { key: 'status', label: 'Estado', style: { width: "10%" } },
        { key: 'appliedAt', label: 'Fecha', style: { width: "10%" } },
        { key: 'actions', label: 'Acciones' }
    ];

    const stageLabels = {
        received: 'Recibida',
        in_review: 'En Revisión',
        interview: 'Entrevista',
        offer: 'Oferta',
        hired: 'Contratado',
        rejected: 'Rechazado'
    };

    const statusLabels = {
        active: 'Activa',
        withdrawn: 'Retirada',
        closed: 'Cerrada'
    };

    const customElements = {
        user: (data) => {
            if (typeof data.user === 'object' && data.user?.name) {
                return <span>{data.user.name} {data.user.lastname}</span>;
            }
            return <span>-</span>;
        },
        job: (data) => {
            const jobOrPractice = data.job || data.practice;
            if (typeof jobOrPractice === 'object' && jobOrPractice?.title) {
                return <span>{jobOrPractice.title}</span>;
            }
            return <span>-</span>;
        },
        applicationType: (data) => {
            const types = {
                job: 'Trabajo',
                practice: 'Práctica'
            };
            return <span>{types[data.applicationType] || data.applicationType}</span>;
        },
        currentStage: (data) => {
            const stageColors = {
                received: '#6B7280',
                in_review: '#3B82F6',
                interview: '#8B5CF6',
                offer: '#10B981',
                hired: '#059669',
                rejected: '#EF4444'
            };
            return (
                <span style={{ 
                    color: stageColors[data.currentStage] || '#6B7280',
                    fontWeight: 600
                }}>
                    {stageLabels[data.currentStage] || data.currentStage}
                </span>
            );
        },
        status: (data) => {
            const statusColors = {
                active: '#10B981',
                withdrawn: '#F59E0B',
                closed: '#6B7280'
            };
            return (
                <span style={{ 
                    color: statusColors[data.status] || '#6B7280',
                    fontWeight: 600
                }}>
                    {statusLabels[data.status] || data.status}
                </span>
            );
        },
        appliedAt: (data) => {
            if (data.appliedAt) {
                const date = new Date(data.appliedAt);
                return <span>{date.toLocaleDateString('es-ES')}</span>;
            }
            return <span>-</span>;
        },
        actions: (data) => (
            <div style={{ display: 'flex', gap: '8px' }}>
                <IconButton onClick={() => handleView(data._id)}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.58 12C15.58 13.98 13.98 15.58 12 15.58C10.02 15.58 8.42004 13.98 8.42004 12C8.42004 10.02 10.02 8.42004 12 8.42004C13.98 8.42004 15.58 10.02 15.58 12Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M12 20.27C15.53 20.27 18.82 18.19 21.11 14.59C22.01 13.18 22.01 10.81 21.11 9.39997C18.82 5.79997 15.53 3.71997 12 3.71997C8.46997 3.71997 5.17997 5.79997 2.88997 9.39997C1.98997 10.81 1.98997 13.18 2.88997 14.59C5.17997 18.19 8.46997 20.27 12 20.27Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </IconButton>
            </div>
        )
    };

    useEffect(() => {
        loadApplications();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const loadApplications = async () => {
        try {
            const data = await getApplications({ limit: 100 });
            setApplications(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error('Error al cargar postulaciones:', err);
        }
    };

    const handleView = (id) => {
        props.history.push(`/talentos/applications/${id}`);
    };

    return (
        <>
            <ToolbarComponent label="Postulaciones" showBackButton={false}>
                {error && (
                    <div style={{ padding: '10px', background: '#FEE2E2', color: '#DC2626', borderRadius: '4px', marginBottom: '16px' }}>
                        {error}
                    </div>
                )}
                <DynamicTable
                    headers={columns}
                    data={applications}
                    customElements={customElements}
                    fullPage={true}
                    showLabel={false}
                    loaderComponent={<Loader text="Cargando postulaciones" />}
                    isLoading={isLoading}
                />
            </ToolbarComponent>
        </>
    );
};

export default ApplicationsPage;

